<template>
  <div>
    <ActionBar
      class="pr-3 align-center"
      show-add
      @add="dialog=true"
      @save="save()"
      show-save
    >
      <template v-slot:left>
        <v-card-title>
          User management
        </v-card-title>
        <v-card-subtitle>
          Please configure the permissions for users within this project
        </v-card-subtitle>
      </template>
    </ActionBar>
    <v-lazy>
    <UserManagementTable class="pa-3" ref="table"></UserManagementTable>
    </v-lazy>
    <UserAddDialog :dialog="dialog" @update:dialog="dialog=$event" />
  </div>

</template>

<script>
  import UserManagementTable from "@/components/userManagement/UserManagementTable.vue"
  import ActionBar from "@/components/common/ActionBar.vue"
  import UserAddDialog from "@/components/userManagement/UserAddDialog.vue"

  export default {
    name: "UserManagementView",
    components: { UserAddDialog, ActionBar, UserManagementTable },
    data: () => ({
      dialog: false
    }),
    methods: {
      async save () {
        await this.$refs.table.saveChanges()
      }
    }
  }
</script>

<style scoped>

</style>
